enum Features {
  ALLOW_RECORD,
  LAST_SHOWS,
  ORDER_CHANNELS,
  P2P,
  START_OVER,
  TIME_SHIFT,
  POWER_SAVING
}

export default Features;
